import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../RushShell/icons';

const relTime = (iso) => {
    if (!iso) return '';
    const diff = Date.now() - new Date(iso).getTime();
    const m = Math.round(diff / 60000);
    if (m < 1) return 'now';
    if (m < 60) return `${m} min`;
    const h = Math.round(m / 60);
    if (h < 24) return `${h}h`;
    const d = Math.round(h / 24);
    return `${d}d`;
};

const initials = (name) => (name || '?')
    .split(' ')
    .map((p) => p[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

const avatarPalette = (idx) => `av-${(idx % 6) + 1}`;

const ActivityCard = ({ items = [] }) => (
    <div className="rs-card col-7">
        <div className="rs-card-h">
            <h3>Team activity</h3>
            <div className="spacer" />
            <Link className="link" to="/dashboard/analytics">
                View all {Icon.arrow}
            </Link>
        </div>
        <div className="act">
            {items.length === 0 && (
                <div className="act-row" style={{ color: 'var(--muted)' }}>
                    <span className="av-s av-1">··</span>
                    <div className="body">No team activity yet — get a project started.</div>
                </div>
            )}
            {items.slice(0, 6).map((it, i) => (
                <div className="act-row" key={it.id || i}>
                    <span className={`av-s ${avatarPalette(i)}`}>{initials(it.actor)}</span>
                    <div className="body" dangerouslySetInnerHTML={{ __html: it.html || '' }} />
                    <span className="when">{relTime(it.createdAt)}</span>
                </div>
            ))}
        </div>
    </div>
);

export default ActivityCard;
